import React from "react";
import styled from "styled-components";
import appConfig from "../../lib/appConfig";
import colours from "../../lib/colours";
import CloseButton from "../atoms/CloseButton";

const HeaderContainer = styled.header`
  height: 46px;
  width: 100%;
  display: flex;
  align-items: center;
  background-color: ${colours.offWhite};
  box-sizing: border-box;
  padding-right: 4px;
  padding-left: 12px;
`;

const TextContainer = styled.div`
  flex: 1;
  text-transform: uppercase;
  font-weight: 400;
  color: ${colours.th1};
`;

const ClosePanelButtonContainer = styled.div`
  text-align: right;
  @media (max-width: ${appConfig.tabletWidth}px) {
    display: none;
  }
`;

interface IProps {
  title: string;
  onClose: any;
}

const PanelHeader = ({ title, onClose }: IProps) => {
  return (
    <HeaderContainer>
      <TextContainer>{title}</TextContainer>
      <ClosePanelButtonContainer>
        <CloseButton onClick={onClose} />
      </ClosePanelButtonContainer>
    </HeaderContainer>
  );
};

export default PanelHeader;
